<template>
  <div class="file-tags">
    <div class="tags-header">
      <i class="iconfont icon-back" @click="closeTag"></i>
      <p>筛选标签</p>
      <span></span>
    </div>
    <div class="tags-content" v-if="!noTag">
      <div v-for="(item, index) in tagList" :key="index" class="tag-item" v-show="item.type !== 4">
        <p class="title">{{item.name}}</p>
        <div class="tag-list">
          <span
            v-for="(tag, tagIndex) in item.contents"
            :key="'tag' + tagIndex"
            :class="{active: tag.active, ellipsis: true}"
            @click="selectTag(item, tag)"
          >{{tag.content}}</span>
        </div>
      </div>
      <div class="tag-item" v-show="adviceTagList.length">
        <p class="title">智能标签</p>
        <div class="tag-list">
          <span
            v-for="(tag, tagIndex) in adviceTagList"
            :key="'tag' + tagIndex"
            :class="{active: tag.contents[0].active, ellipsis: true}"
            @click="selectAdviceTag(tag)"
          >{{tag.contents[0].content}}</span>
        </div>
      </div>
    </div>
    <div class="no-tag" v-else>
      <img src="https://p5.ssl.qhimg.com/t110b9a93019a820ae6cc60c7ca.png" alt="">
      <span>暂无标签</span>
    </div>

    <div class="button-bottom" v-show="!noTag">
      <span @click="resetTagActive">重置</span>
      <span class="save" @click="saveTagActive">完成</span>
    </div>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import { META_TAG_LIST, META_ADVICE_TAG_LIST } from '@/config/api'
import config from '@/config'
export default {
  name: 'TagList',
  props: {
    activeTagList: {
      type: Array,
      default: () => []
    }
  },
  components: {

  },
  data () {
    return {
      newCardData: {},
      tagList: [],
      adviceTagList: [],
      activeTagObj: {},
      noTag: false
    }
  },
  created () {
    this.initTagsList()
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    initTagsList () {
      const promiseList = [
        ajax({
          url: META_TAG_LIST + `?library_id=${this.$route.params.library_id || '60b9e001a682ff215188e0d1f44efb41'}`,
          baseUrl: config.doclib_application_url,
          noPrefix: true
        }),
        ajax({
          url: META_ADVICE_TAG_LIST + `?document_id=0&library_id=${this.$route.params.library_id || '60b9e001a682ff215188e0d1f44efb41'}`,
          baseUrl: config.doclib_application_url,
          noPrefix: true
        })
      ]
      Promise.all(promiseList).then((values) => {
        if (values.every(item => item.success)) {
          this.setActiveTag(values[0].data, values[1].data)
        }
      })
    },

    setActiveTag (tagList, adviceTagList) {
      if (tagList.length) {
        tagList.length && tagList.forEach(item => {
          item.contents.unshift({
            id: 0,
            content: '不限',
            active: false
          })
          item.contents.length && item.contents.forEach((content, contentIndex) => {
            if (this.activeTagList.length) {
              content.active = !!(this.activeTagList.includes(item.id + '-' + content.id))
            } else {
              content.active = !!(contentIndex === 0)
            }
          })
        })
      }

      if (adviceTagList.length) {
        adviceTagList.unshift({
          id: 0,
          name: '智能标签',
          contents: [{
            id: 0,
            content: '不限',
            active: false
          }]
        })

        adviceTagList.length && adviceTagList.forEach((item, itemIndex) => {
          if (this.activeTagList.length) {
            item.contents[0].active = !!(this.activeTagList.includes(item.id + '-' + item.contents[0].id))
          } else {
            item.contents[0].active = !!(itemIndex === 0)
          }
        })
      }

      this.tagList = tagList.concat([])
      this.adviceTagList = adviceTagList.concat([])

      if (!tagList.length && !adviceTagList.length) {
        this.noTag = true
      }
    },

    selectTag (tag, content) {
      let tagList = this.tagList.concat([])

      tagList.length && tagList.forEach(item => {
        if (item.id === tag.id) {
          let hasActive = false

          if (content.id === 0 && !item.contents[0].active) {
            item.contents.forEach(contentItem => {
              contentItem.active = false
            })

            item.contents[0].active = true
            return
          }

          item.contents.forEach(contentItem => {
            if (tag.type === 1) {
              contentItem.active = contentItem.id === content.id && !content.active
            } else {
              if (contentItem.id === content.id) {
                contentItem.active = !contentItem.active
              }
            }

            if (contentItem.active) {
              hasActive = true
            }
          })

          if (hasActive) {
            item.contents[0].active = false
          }

          item.contents[0].active = !hasActive
        }
      })

      this.tagList = tagList.concat([])
    },

    selectAdviceTag (tag) {
      let adviceTagList = this.adviceTagList.concat([])
      let hasActive = false

      if (tag.id === 0 && !adviceTagList[0].contents[0].active) {
        adviceTagList.forEach(item => {
          item.contents[0].active = false
        })
        adviceTagList[0].contents[0].active = true
        return
      }

      adviceTagList.forEach(item => {
        if (item.id === tag.id) {
          item.contents[0].active = !item.contents[0].active
        }

        if (item.contents[0].active) {
          hasActive = true
        }
      })

      adviceTagList[0].contents[0].active = !hasActive

      this.adviceTagList = adviceTagList.concat([])
    },

    resetTagActive () {
      let tagList = this.tagList.concat([])
      let adviceTagList = this.adviceTagList.concat([])

      if (tagList.length) {
        tagList.length && tagList.forEach(item => {
          item.contents.length && item.contents.forEach(content => {
            content.active = false
          })
          item.contents[0].active = true
        })
      }

      if (adviceTagList.length) {
        adviceTagList.length && adviceTagList.forEach(item => {
          item.contents[0].active = false
        })

        adviceTagList[0].contents[0].active = true
      }

      this.tagList = tagList.concat([])
      this.adviceTagList = adviceTagList.concat([])
    },

    saveTagActive () {
      let tagList = this.tagList.concat([])
      let adviceTagList = this.adviceTagList.concat([])
      let activeList = []
      let activeTagData = []

      if (tagList.length) {
        tagList.length && tagList.forEach(item => {
          item.contents.length && item.contents.forEach(content => {
            if (content.active) {
              activeList.push(item.id + '-' + content.id)
              if (content.id !== 0) {
                activeTagData.push({
                  content_id: content.id,
                  tag_id: item.id
                })
              }
            }
          })
        })
      }

      if (adviceTagList.length) {
        adviceTagList.length && adviceTagList.forEach(item => {
          if (item.contents[0].active) {
            activeList.push(item.id + '-' + item.contents[0].id)
            if (item.contents[0].id !== 0) {
              activeTagData.push({
                content_id: item.contents[0].id,
                tag_id: item.id
              })
            }
          }
        })
      }

      this.$emit('save-tag-active', activeList.concat([]), activeTagData)
    },

    closeTag () {
      this.$emit('close-tag-dialog-fn')
    }
  }
}
</script>
<style lang="postcss" scoped>
.file-tags {
  height: 100%;

  & .tags-header {
    width: 100%;
    display: flex;
    height: 44px;
    padding: 0px 20px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    &>p {
      display: flex;
      align-items: center;
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;

      & img {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
    }

    &>i {
      color: #1B2532;
      font-size: 16px;
      line-height: normal;
    }

    &>span {
      width: 20px;
    }
  }

  & .tags-content {
    height: calc(100% - 120px);
    overflow: auto;

    & .tag-item {
      margin-top: 20px;

      & .title {
        display: flex;
        padding: 4px 20px;
        color:#1B2532;
        font-family: "PingFang SC";
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        box-sizing: border-box;
      }

      & .tag-list {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 0 20px;
        width: 100%;
        box-sizing: border-box;

        & span {
          display: block;
          width: calc((100% - 24px) / 3);
          height: 34px;
          line-height: 34px;
          text-align: center;
          padding: 0 12px;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          background: #F2F7FF;
          border: 1px solid #F2F7FF;
          box-sizing: border-box;
          color: #1B2532;
          font-family: "PingFang SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-top: 12px;
          margin-right: 12px;
          box-sizing: border-box;

          &:nth-child(3n) {
            margin-right: 0;
          }

          &.active {
            border: 1px solid #006BFF;
          }
        }
      }
    }
  }

  & .button-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 56px;
    padding: 8px 20px 42px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;

    & span {
      width: calc((100% - 16px) / 2);
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      border: 1px solid #D8E0E8;
      background: #fff;
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      &.save {
        background: #006BFF;
        border: 1px solid #006BFF;
        color: #fff;
      }
    }
  }

  & .no-tag{
    height: calc(100% - 120px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -60px;

    & img {
      width: 220px;
      flex-shrink: 0;
    }

    & span {
      color: #9EA7B8;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin-top: 4px;
    }
  }
}
</style>
